import { useMutation } from '@tanstack/react-query';
import { IAddAdmins, IAddAdminsResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const addAdmin = async (body: IAddAdmins) => {
  const res = await apiManager.post<IAddAdminsResponse>(
    "/auth/admin/register",
    body
  );
  return res;
};


export const useAddAdmin = () =>
  useMutation({
    mutationFn: async (body: IAddAdmins): Promise<IAddAdminsResponse> => {
      const res = await apiClient.post(ENDPOINTS.ADMIN.ADD_ADMIN, body);
      return res.data;
    },
  });